// AirtableTokenHelp.js
import React from 'react';
import { Box, Typography, List, ListItem } from '@mui/material';
import '../Docs.css';

export default function AirtableTokenHelp() {
  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h2" gutterBottom>
        Generating an Airtable&nbsp;Personal&nbsp;Access&nbsp;Token
      </Typography>

      <Typography paragraph>
        Create a scoped token in Airtable’s Builder Hub and paste it into PostSheet.
      </Typography>

      <List className="steps-vertical" sx={{ ml: '2rem' }}>
        <ListItem sx={{ ml: '1rem' }}>
          <Typography variant="h4">
            1&nbsp;·&nbsp;Sign in at&nbsp;
            <a href="https://airtable.com" target="_blank" rel="noopener noreferrer">airtable.com</a>.
          </Typography>
        </ListItem>

        <ListItem sx={{ ml: '1rem' }}>
          <Typography variant="h4">
            2&nbsp;·&nbsp;Click your avatar and choose&nbsp;<strong>Builder&nbsp;Hub</strong>.
          </Typography>
          <img src="../../static/docs/airtablebuilderhub.jpg" alt="Open Builder Hub" className="step-img" />
        </ListItem>

        <ListItem sx={{ ml: '1rem' }}>
          <Typography variant="h4">
            3&nbsp;·&nbsp;Select&nbsp;<strong>Personal Access Tokens</strong>, then&nbsp;<em>Create new token</em>.
          </Typography>
          <img src="../../static/docs/builderhubselect.jpg" alt="Personal Access Tokens menu" className="step-img" />
        </ListItem>

        <ListItem sx={{ ml: '1rem' }}>
          <Typography variant="h4">
            4&nbsp;·&nbsp;Name the token and tick required scopes:
             <ul style={{ marginLeft: '0.6rem' }}>
    <li><code>data.records:read</code> – read records</li>
    <li><code>schema.bases:read</code> – read base structure</li>
    <li><code>user.email:read</code> – identify the owner</li>
  </ul>
          </Typography>
          <img src="../../static/docs/NameToken.jpg" alt="Name token & choose scopes" className="step-img" />
        </ListItem>

        <ListItem sx={{ ml: '1rem' }}>
          <Typography variant="h4">
            5&nbsp;·&nbsp;Pick workspaces the token can access (e.g.&nbsp;<strong>All resources</strong>).
          </Typography>
          <img src="../../static/docs/SelectScopeAirtable.jpg" alt="Select workspaces" className="step-img" />
        </ListItem>

        <ListItem sx={{ ml: '1rem' }}>
          <Typography variant="h4">
            6&nbsp;·&nbsp;Click&nbsp;<strong>Create&nbsp;token</strong>, copy it and paste into PostSheet.
          </Typography>
          <img src="../../static/docs/AirtableToken.jpg" alt="Copy generated token" className="step-img" />
        </ListItem>
      </List>
    </Box>
  );
}
